import { IonButtons, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { heartHalf, star, newspaper, heart, trendingUp, time } from 'ionicons/icons';
import { ContentInfo, ContentUpdateInt } from '../data/item';
import React, { Component }  from 'react';

import { LANGUAGE, GetStr } from "../language/Language";

import '../pages/Main.css'; 

interface CategoryChip {
    icon : any,
    title : number
};

const categories : CategoryChip[] = [
    { icon: star, title: LANGUAGE.TXT_CAT_POPULAR },
    { icon: newspaper, title: LANGUAGE.TXT_CAT_NEWS },
    { icon: trendingUp, title: LANGUAGE.TXT_CAT_TRENDING },
    { icon: time, title: LANGUAGE.TXT_CAT_LATEST },
    { icon: heartHalf, title: LANGUAGE.TXT_CAT_NSFW }
];
  
const CategoriesContent : React.FC<ContentUpdateInt> = ({ content, index, onUpdate }) => {
    
    const router = useIonRouter();

    const showCategory = (cat : number) => {
        onUpdate(cat, content);
    }

    return (
        <div className="categories-content">
            <div className="button-bar">
                { 
                    categories.map( (m, index) =>
                        <IonChip className={ content.id == index ? "cat-chip" : "ion-hide" } key={index}>
                            <IonIcon icon={m.icon} color="primary" />
                            <IonLabel color="primary"><b>{ GetStr(m.title) }</b></IonLabel>
                        </IonChip>
                    ) 
                }
                { 
                    categories.map( (m, index) =>
                        <IonChip className={ content.id != index ? "cat-chip" : "ion-hide" } key={index} onClick={()=>showCategory(index)}>
                            <IonIcon icon={m.icon} color="dark" />
                            <IonLabel color="dark">{ GetStr(m.title) }</IonLabel>
                        </IonChip>
                    ) 
                }

                {/*
                <IonChip onClick={()=>showCategory(0)}>
                    <IonIcon icon={star} color={ content.id == 0 ? "primary" : "dark" }/>
                    <IonLabel color={ content.id == 0 ? "primary" : "dark" }>{ GetStr(LANGUAGE.TXT_CAT_POPULAR) }</IonLabel>
                </IonChip>
                <IonChip onClick={()=>showCategory(1)} >
                    <IonIcon icon={newspaper} color={ content.id == 1 ? "primary" : "dark" } />
                    <IonLabel color={ content.id == 1 ? "primary" : "dark" }>{ GetStr(LANGUAGE.TXT_CAT_NEWS) }</IonLabel>
                </IonChip>
                <IonChip onClick={()=>showCategory(2)} >
                    <IonIcon icon={trendingUp} color={ content.id == 2 ? "primary" : "dark" } />
                    <IonLabel color={ content.id == 2 ? "primary" : "dark" }>{ GetStr(LANGUAGE.TXT_CAT_TRENDING) }</IonLabel>
                </IonChip>
                <IonChip onClick={()=>showCategory(3)} >
                    <IonIcon icon={time} color={ content.id == 3 ? "primary" : "dark" } />
                    <IonLabel color={ content.id == 3 ? "primary" : "dark" }>{ GetStr(LANGUAGE.TXT_CAT_LATEST) }</IonLabel>
                </IonChip>
                <IonChip onClick={()=>showCategory(4)} >
                    <IonIcon icon={heartHalf} color={ content.id == 4 ? "primary" : "dark" } />
                    <IonLabel color={ content.id == 3 ? "primary" : "dark" }>{ GetStr(LANGUAGE.TXT_CAT_NSFW) }</IonLabel>
                </IonChip>
                */}
            </div>
        </div>
    );
};
  
export default CategoriesContent;